import {
  SchemaControl,
  type SchemaControlArgs,
  type ValidatorFn,
} from '@/modules/common/models/schema/schema-control.ts';
import UiInput from '@/modules/ui/components/ui/UiInput.vue';
import Validator from '@/modules/common/utils/validator.ts';
import type { MaskInputOptions } from 'maska';

type SchemaInputType = 'text' | 'time';

type SchemaInputArgs = SchemaControlArgs & {
  placeholder?: string;
  maxLength?: number;
  type?: SchemaInputType;
  mask?: MaskInputOptions | string;
  validators?: ValidatorFn<string>[];
};

export class SchemaInput extends SchemaControl<string> {
  readonly component = UiInput;
  readonly placeholder?: string;
  readonly maxLength?: number;
  readonly autocomplete = 'off';
  readonly type: SchemaInputType;
  readonly mask?: MaskInputOptions | string;

  constructor(args: SchemaInputArgs) {
    super(args);

    this.placeholder = args.placeholder;
    this.maxLength = args.maxLength;
    this.type = args.type || 'text';
    this.mask = args.mask ?? this.setMask(this.type);
    this.setValidators(this.type);
    args.validators?.forEach((validator) => this.addValidator(validator));
  }

  private setMask(type: SchemaInputType) {
    if (type === 'time') {
      return '##:##';
    }
  }

  private setValidators(type: SchemaInputType) {
    if (type === 'time') {
      this.addValidator(Validator.time);
    }
  }
}
